const schema = () => ({
  type: "object",
  required: [],
  properties: {
    firstname: {
      type: "string",
      title: "نام",
    },
    lastname: {
      type: "string",
      title: "نام خانوادگی",
    },
    national_code: {
      type: "string",
      title: "کد ملی",
      minLength: 10,
      maxLength: 10,
      pattern: "^[0-9]{10}$",
    },
    birth_date: {
      type: "string",
      title: "تاریخ تولد",
      format: "date",
    },
    gender: {
      type: "number",
      title: "جنسیت",
      oneOf: [
        { const: 1, title: "آقا" },
        { const: 0, title: "خانم" },
      ],
    },
    email: {
      type: "string",
      title: "پست الکترونیک",
      format: "email",
    },
  },
});

export default schema;
